import React, { useState, useEffect, useCallback } from 'react';
import TableWrapper from '../../components/Grid';
import ReactAudioPlayer from 'react-audio-player';

import {
    Avatar,
    Col,
    Row,
    Form,
    Select,
    Tabs,
    Divider,
    Tooltip,
    Grid,
} from 'antd';
import { Link } from 'react-router-dom';
import {
    LoadingOutlined,
    UserOutlined,
    PlusOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { TextField, ScrollEndMessage } from '../../components';
import BasicText from '../../components/Text/BasicText';
import DropDown from '../../components/DropDown';
import FilterBar from '../../components/FilterBar';
import { AddUserSchema } from '../../config/Schema';
import moment from 'moment';
// import LoadingOutlined from 'react-icons/ai'
// import AiOutlineSearch from 'react-icons/ai'
// import { Avatar } from '../../components';
import { AiOutlineLoading } from 'react-icons/ai';
import { LuUser } from 'react-icons/lu';
import { FaBars, FaCamera } from 'react-icons/fa';
import { FaEye } from 'react-icons/fa';
import { FaBan } from 'react-icons/fa';
import { IoIosArrowForward, IoIosPower, IoIosSearch } from 'react-icons/io';
import { CiEdit } from 'react-icons/ci';
import camera from '../../assets/images/camera.png';

// import { TextField } from '../../components';
import BasicDrawaer from '../../components/Drawer';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AdduserForm } from '../../config/Schema';
import LabelWithField from '../../components/LabelWithField';
import LabelWithSelect from '../../components/LabelWithSelect';
import LabelWithDate from '../../components/LabelWithDate';
import Button from '../../components/Button';
import Text from '../../components/Text';
import { Colors } from '../../config';
import {
    getEligibiity,
    getSchedules,
    getUserRoles,
} from '../../config/getApis';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import {
    AlertManagementAction,
    AppAction,
    UserManagementAction,
} from '../../store/actions';
import { useNavigate } from 'react-router';
import { Spin } from 'antd';
import Circular from '../../components/Loader/Circular';
import ButtonLoader from '../../components/Button/ButtonLoader';
import dayjs from 'dayjs';
import ActionDropdown from '../../components/DropDown/actiondropdown';
import UserDetailDrawer from './UserDetailDrawer';
// import UserAddnEditDrawer from './UserAddnEditDrawer';
import useColors from '../../hooks/useColors';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import NotificationDemo from '../../components/EmergencyAlert';
import AlertCard from '../../components/EmergencyAlert';
import DashboardActionBar from '../../components/DashboardActionBar';

const { TabPane } = Tabs;

const AlertManagement = () => {
    const dispatch = useDispatch();
    const scrn = Grid.useBreakpoint();
    const navigate = useNavigate();

    const userData = useSelector(
        (state) => state?.UserManagementReducer?.UserData,
    );
    const alertData = useSelector(
        (state) => state?.AlertManagementReducer?.AlertData,
    );
    const loader = useSelector(
        (state) => state?.AlertManagementReducer?.loader,
    );
    const alertsError = useSelector(
        (state) => state?.AlertManagementReducer?.alertsError,
    );

    const userDetailData = useSelector(
        (state) => state?.AlertManagementReducer?.AlertDetailData,
    );

    const userAddLoader = useSelector(
        (state) => state?.UserManagementReducer?.AddUserLoader,
    );
    const userDetailLoader = useSelector(
        (state) => state?.UserManagementReducer?.DetailUserLoader,
    );
    const user = useSelector((state) => state?.AppReducer?.user);
    const isRole = user?.userRole[0];
    const { colorPrimary } = useColors();

    const { notificationCount } = useSelector((state) => state?.GeneralReducer);


    const tableData = alertData?.data?.data;
    const paginate = alertData?.data?.paginate;

    console.log('paginatte', paginate?.total);

    const [state, setState] = useState({
        isRecent: 0,
        current: 1,
        limit: 20,
        searchVal: '',
        tabName: 'active',
        roleType: '',
    });

    const [accumulatedAlerts, setAccumulatedAlerts] = useState([]);

    useEffect(() => {
        dispatch(AlertManagementAction.GetAlerts(state));
    }, [state.current, state.limit, state.searchVal, state.isRecent, state.tabName, state.roleType]);

    useEffect(() => {
        setAccumulatedAlerts([]);
    }, [state.isRecent, state.tabName, state.searchVal, state.roleType]);

    useEffect(() => {
        if (tableData) {
            if (state.current === 1) {
                setAccumulatedAlerts(tableData);
            } else {
                setAccumulatedAlerts((prev) => {
                    const existingIds = new Set(prev.map((a) => a.id));
                    const newAlerts = tableData.filter((a) => !existingIds.has(a.id));
                    return [...prev, ...newAlerts];
                });
            }
        }
    }, [tableData, state.current]);

    useEffect(() => {
        if (alertsError) {
            setAccumulatedAlerts([]);
        }
    }, [alertsError]);

    const hasMore = paginate ? (paginate.currentPage < paginate.lastPage) : true;

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (!container) return;

        const handleScroll = () => {
            const isNearBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 100;
            if (isNearBottom && !loader && hasMore) {
                setState((prev) => ({
                    ...prev,
                    current: prev.current + 1,
                }));
            }
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [loader, hasMore]);

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (container) {
            container.scrollTop = 0;
        }
    }, [state.isRecent]);

    const { data: eligibilityData } = useQuery('eligibility', getEligibiity);
    const { data: scheduleData } = useQuery('schedules', getSchedules);
    const { data: rolesData } = useQuery('roles', getUserRoles);
    console.log(eligibilityData);

    if (rolesData && isRole === 'manager') {
        for (let i = 0; i < rolesData.length; i++) {
            if (rolesData[i]?.label === 'admin') {
                rolesData.splice(i, 1);
                i--;
            }
        }
    }

    // img work
    const [img, setimg] = useState(null);
    const [readFile, setReadFile] = useState(null);

    // Drawers maintaining states.
    const [drawerStates, setDrawerStates] = useState({
        openDrawer: false,
        userDetailDrawer: false,
        drawerkey: null,
        userid: null,
    });

    // Image Validation handling
    const [imgValue, setImageValue] = useState({
        imgSizeValidation: '',
        imgTypeValidation: '',
        isRequired: '',
    });

    // Tab Change handling
    const tabChange = (key) => {
        if (key == 1) {
            setState((prev) => ({
                ...prev,
                current: 1,
                limit: 20,
                searchVal: '',
                isRecent: 0,
                tabName: 'active',
            }));
        } else {
            setState((prev) => ({
                ...prev,
                isRecent: 1,
                current: 1,
                limit: 20,
                searchVal: '',
                tabName: 'inActive',
            }));
        }
    };

    const dropDownSelector = (e) => {
        if (e.key === 'tmp-0') {
            navigate('/MyAvailability');
            return;
        } else if (e.key === 'tmp-1') {
            navigate('/EditProfile');
            return;
        } else if (e.key === 'tmp-2') {
            console.log(e.key);
            navigate('/ChangePassword');
            return;
        }
        // else if (e.key === 'tmp-3') {
        //     navigate('/Notifications')
        // }
    };

    // Add user Drawer
    const onCloseDrawer = () => {
        if (drawerStates?.drawerkey == 1 && drawerStates.userDetailDrawer) {
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: false,
                drawerkey: null,
                userid: null,
            });
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            reset();
        } else {
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: false,
                userid: null,
            });
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            dispatch(AlertManagementAction.GetAlerts());
            reset();
        }
    };

    const drawerKeyHandler = (isOpen, reset) => {
        if (!isOpen) {
            setDrawerStates({ ...state, drawerkey: null });
            setReadFile(null);
            reset();
        }
    };

    // this will run only after closing of detail drawer.
    const detailDrawerReset = (isOpen) => {
        if (!isOpen && !drawerStates.openDrawer) {
            dispatch(UserManagementAction.UserDetailReset());
        }
    };

    // Form related Working
    let schema = AddUserSchema;
    const {
        handleSubmit,
        control,
        reset,
        setValue,
        watch,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        // mode: 'onChange'
    });

    // form data
    const FormDataHandler = (data) => {
        const file = watch(data?.userimg);

        if (Object.keys(errors).length > 0) {
            setError('phoneNo', {
                type: 'format',
                message: errors?.phoneNo?.message,
            });
            return;
        } else if (imgValue?.imgSizeValidation || imgValue.imgTypeValidation) {
            return;
        }

        //setting the key null is important as when the buttons inside the drawers clicked the key is already
        //select to 1 from the dropdown selection and for the future actions it will remain 1 if we didn't -
        //handle it.
        else {
            if (drawerStates.drawerkey == 1) {
                // for dispatching form action about UPDATE USER CASE.
                let certificationInfo = {};
                for (const key in data) {
                    if (data[key] instanceof Date) {
                        certificationInfo[key] = moment(data[key]).format(
                            'DD-MM-YYYY',
                        );
                        delete data[key];
                    }
                }

                data['certificationInfo'] = certificationInfo;
                const id = Number(drawerStates?.userid);

                certificationInfo &&
                    dispatch(
                        UserManagementAction.UpdateUser(data, id, () => {
                            dispatch(UserManagementAction.GetUsers(state));
                            dispatch(UserManagementAction.UserDetailReset());
                            setDrawerStates({
                                ...drawerStates,
                                openDrawer: false,
                                userDetailDrawer: false,
                                drawerkey: null,
                            });
                            reset();
                            setReadFile(null);
                        }),
                    );
                return;
            } else {
                // for dispatching form action about ADD USER CASE.
                // setting an object, as api expects date in a different objects so modifying for it.

                let certificationInfo = {};
                for (const key in data) {
                    if (data[key] instanceof Date) {
                        certificationInfo[key] = moment(data[key]).format(
                            'DD-MM-YYYY',
                        );
                        delete data[key];
                    }
                }

                data['certificationInfo'] = certificationInfo;

                // if certificationInfo contain some data i.e dates so we'll dispatch an actions only.
                certificationInfo &&
                    dispatch(
                        UserManagementAction.AddUsers(data, () => {
                            dispatch(UserManagementAction.GetUsers(state));
                            setDrawerStates({
                                ...drawerStates,
                                openDrawer: false,
                                userDetailDrawer: false,
                                drawerkey: null,
                            });
                            reset();
                            setReadFile(null);
                        }),
                    );
            }

            return;
        }
    };

    const debouceHandler = (query, delay) => {
        let timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            dispatch(
                AlertManagementAction.GetAlerts({
                    ...state,
                    searchVal: query,
                    current: 1,
                }),
            );
        }, delay);
    };

    // user search bar filter handler
    const handleInputChange = (e) => {
        const query = e?.target.value;
        setState({ ...state, current: 1, searchVal: e.target.value });
        debouceHandler(query, 3000);
    };

    // items for Action.
    // items for Action.
    const items = [
        {
            label: 'View Details',
            key: 1,
            icon: <FaEye color="#5B93FF" />,
            backgroundColor: '#EEF4FF',
            color: '#5B93FF',
        },
    ];
    // for Action dropdown
    const ActionHandler = (e, record) => {
        const { current, limit, searchVal } = state;

        // Open the drawer
        setDrawerStates({
            ...drawerStates,
            openDrawer: false,
            userDetailDrawer: true,
            drawerkey: 1,
            userid: record?.id, // Set the user ID in the drawer state
        });

        // Prepare the payload
        let payload = {
            id: Number(record?.id), // Include user ID in the payload
        };

        console.log(
            'Dispatching AlertManagementAction.GetAlerts with payload:',
            payload,
        );

        // Dispatch the API call
        dispatch(
            AlertManagementAction.GetAlertDetail(payload, () => {
                console.log('API Callback executed');
                setState({
                    ...state,
                    current: current,
                    limit: limit,
                    searchVal: searchVal,
                });
            }),
        );
    };

    const handleRowClick = (record, event) => {
        if (
            event.target.closest('audio') ||
            event.target.closest('.w-76') ||
            event.target.closest('.ant-dropdown-trigger')
        ) {
            return;
        }

        const { current, limit, searchVal } = state;
        setDrawerStates({
            ...drawerStates,
            openDrawer: false,
            userDetailDrawer: true,
            drawerkey: 1,
            userid: record?.id,
        });

        let payload = {
            id: Number(record?.id),
        };

        dispatch(
            AlertManagementAction.GetAlertDetail(payload, () => {
                setState({
                    ...state,
                    current: current,
                    limit: limit,
                    searchVal: searchVal,
                });
            }),
        );
    };

    // edit user button-handler in a drawer
    const UserEditHandler = () => {
        console.log(drawerStates);
        setDrawerStates({
            ...drawerStates,
            userDetailDrawer: false,
            openDrawer: true,
        });
        if (userDetailData?.profileImg[0]?.url) {
            setReadFile(userDetailData?.profileImg[0]?.url);
        }
        // reset(userDetailData)
    };

    // Add New User handler
    const AddUserHandler = () => {
        if (readFile) {
            setReadFile(null);
            setDrawerStates({
                ...drawerStates,
                userDetailDrawer: false,
                openDrawer: true,
            });
        } else {
            setDrawerStates({
                ...drawerStates,
                userDetailDrawer: false,
                openDrawer: true,
            });
        }
    };

    // ACTIVE USERS COLUMNS
    const columns = [
        {
            title: 'Name',
            dataIndex: 'userName',
            align: 'left',
            render: (text, record) => (
                <Row
                    justify={'center'}
                    className="flex justify-start items-center"
                >
                    <Col span={24} className="flex justify-start items-center">
                        {record?.profileImg ? (
                            <Avatar
                                className="mr-5"
                                size={40}
                                src={record?.profileImg[0]?.url}
                            />
                        ) : (
                            <Avatar
                                className="mr-5"
                                size={40}
                                icon={<UserOutlined />}
                            />
                        )}
                        <span>
                            {record?.user?.firstName +
                                ' ' +
                                record?.user?.lastName}
                        </span>
                    </Col>
                </Row>
            ),
        },
        {
            title: 'Audio',
            dataIndex: 'audio',
            key: 'audio',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-start align-center w-full"
                    >
                        {record?.voiceNote[0]?.url ? (
                            <ReactAudioPlayer
                                src={record?.voiceNote[0]?.url}
                                controls
                                className="w-76"
                            />
                        ) : (
                            <span>No Audio Available</span>
                        )}
                    </Col>
                );
            },
        },

        {
            title: 'Role',
            dataIndex: 'userRole',
            key: 'role',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.user?.userRole[0]?.name}</span>
                    </Col>
                );
            },
        },
        // {
        //     title: 'Note',
        //     dataIndex: 'note',
        //     key: 'note',
        //     render: (text, record) => {
        //         return (
        //             <Col
        //                 span={24}
        //                 className="w-full flex justify-start align-center flex-wrap"
        //             >
        //                 <span className="break-all">{record?.email}</span>
        //             </Col>
        //         );
        //     },
        // },

        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, record) => {
                const formattedDate = record?.createdAt
                    ? moment(record.createdAt).format('MM/DD/YYYY h:mm a')
                    : '-';
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{formattedDate}</span>
                    </Col>
                );
            },
        },

        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-center align-center">
                        <ActionDropdown
                            items={items}
                            placement={'bottom'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => ActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];

    const phoneNumberFormat = (number) => {
        const cleaned = ('', number).replace(/\D/g, '');
        let phoneNumber;

        if (cleaned.length === 10) {
            return (phoneNumber =
                '(' +
                cleaned.substr(0, 3) +
                ') ' +
                cleaned.substr(3, 3) +
                '-' +
                cleaned.substr(6, 4));
        } else {
            return;
        }
    };
    // user Select Values
    const SelectFilterValues = [
        {
            value: 'admin',
            label: 'Admin',
        },
        {
            value: 'supervisor',
            label: 'Supervisor',
        },
        {
            value: 'guard',
            label: 'Guard',
        },
        {
            value: 'manager',
            label: 'Manager',
        },
        {
            value: '',
            label: 'View All',
        },
    ];

    // const options = [
    //     { label: 'My Availability', value: '1' },
    //     { label: 'Edit Profile', value: '2' },
    //     { label: 'Change Password', value: '3' },
    // ];

    const options = [
        { label: 'My Availability', value: '1' },
        { label: 'Edit Profile', value: '2' },
        { label: 'Change Password', value: '3' },
        // { label: 'Notifications', value: '4' }
    ];

    const SelectFilterHandler = (value) => {
        const { tabName } = state;
        dispatch(
            AlertManagementAction.GetAlerts({
                ...state,
                current: 1,
                limit: 20,
                searchVal: '',
                tabName: tabName,
                roleType: value,
            }),
        );
        setState({
            ...state,
            current: 1,
            limit: 20,
            searchVal: '',
            tabName: tabName,
            roleType: value,
        });
    };

    return (
        <>
            {/* <UserAddnEditDrawer
                drawerStates={drawerStates}
                drawerKeyHandler={drawerKeyHandler}
                onCloseDrawer={onCloseDrawer}
                userDetailData={userDetailData}
                phoneNumberFormat={phoneNumberFormat}
                FormDataHandler={FormDataHandler}
                userAddLoader={userAddLoader}
                eligibilityData={eligibilityData}
                scheduleData={scheduleData}
                rolesData={rolesData}
                img={img}
                setimg={setimg}
                imgValue={imgValue}
                setImageValue={setImageValue}
                readFile={readFile}
                setReadFile={setReadFile}
            /> */}

            <UserDetailDrawer
                onCloseDrawer={onCloseDrawer}
                detailDrawerReset={detailDrawerReset}
                drawerStates={drawerStates}
                userDetailLoader={userDetailLoader}
                userDetailData={userDetailData}
                UserEditHandler={UserEditHandler}
                isRole={isRole}
            />

            {/* 
            <FilterBar
                SelectFilterHandler={SelectFilterHandler}
                // SelectFilterValues={SelectFilterValues}
                AddUserHandler={AddUserHandler}
                handleInputChange={(e) => handleInputChange(e)}
                SearchValue={state?.searchVal}
                title="User Management"
                btnText="Add New User"
                isRole={isRole}
                defaultValue={''}
                classname={'mb-12'}
            /> */}
            
            <DashboardActionBar
                text='Security Alerts'
            />

            <Row
                gutter={[8, 32]}
                className="w-fit bg-white p-4 rounded-lg sm:w-fit lg:w-fit xl:w-full"
            >
                <Col lg={24}>
                    <Row className="w-full">
                        <Col lg={24}>
                            <Tabs
                                defaultActiveKey="1"
                                itemSelectedColor="black"
                                className="-mt-16 font-medium
"
                                onChange={tabChange}
                                items={[
                                    {
                                        label: 'Alert',
                                        key: '1',
                                        children: (
                                            <>
                                                <TableWrapper
                                                    tableStyle={{
                                                        borderRadius: '40px',
                                                        width: '100%',
                                                    }}
                                                    headerbg={'red'}
                                                    tableColumns={columns}
                                                    tableData={accumulatedAlerts}
                                                    pagination={false}
                                                    rowClassName={'row-antd'}
                                                    onRow={(record) => ({
                                                        onClick: (event) => handleRowClick(record, event),
                                                    })}
                                                />
                                                {loader && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                                                        <Spin />
                                                    </div>
                                                )}
                                                <ScrollEndMessage
                                                    hasMore={hasMore}
                                                    loading={loader}
                                                    dataLength={accumulatedAlerts?.length}
                                                />
                                            </>
                                        ),
                                    },

                                    {
                                        label: 'Recent Alert',
                                        key: '2',
                                        children: (
                                            <>
                                                <TableWrapper
                                                    tableStyle={{
                                                        borderRadius: '40px',
                                                    }}
                                                    headerbg={'red'}
                                                    tableColumns={columns}
                                                    tableData={accumulatedAlerts}
                                                    pagination={false}
                                                    rowClassName={'row-antd'}
                                                    onRow={(record) => ({
                                                        onClick: (event) => handleRowClick(record, event),
                                                    })}
                                                />
                                                {loader && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                                                        <Spin />
                                                    </div>
                                                )}
                                                <ScrollEndMessage
                                                    hasMore={hasMore}
                                                    loading={loader}
                                                    dataLength={accumulatedAlerts?.length}
                                                />
                                            </>
                                        ),
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default AlertManagement;
